export default [
  'it',
  'en',
];
